import React, { useEffect, useState } from 'react';

import Footer from './footer';
import Header from './header';

import { useClientOnlyCart as useCart } from '../shared/shopify/hooks/useClientOnlyCart';

interface LayoutProps {
  children?: React.ReactNode
  location: Location
  isSiteFramed?: boolean
}

const Layout: React.FC<LayoutProps> = ({ children, location, isSiteFramed }) => {
  // const reviewsEnabled = Boolean(process.env.GATSBY_JUDGEME_PUBLIC_TOKEN) && location.search?.indexOf('judgeme_review_source') > -1;
  const cart = useCart();
  const [appliedDiscount, setAppliedDiscount] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const discount = urlParams.get('discount');
    if (discount) {
      localStorage.setItem('discount', discount)
    }
  }, [location])

  useEffect(() => {
    const discount = localStorage.getItem('discount');

    if (!appliedDiscount && discount && cart.cartReady) {
      if (cart.status === 'idle') {
        setAppliedDiscount(true)
        cart.discountCodesUpdate([discount]);
      }
    }
  }, [cart.status])

  // console.log('heree', { reviewsEnabled, location })
  // if (reviewsEnabled) {

  //   useJudgeme({
  //     shopDomain: process.env.GATSBY_SHOPIFY_MYSHOPIFY_DOMAIN,
  //     publicToken: process.env.GATSBY_JUDGEME_PUBLIC_TOKEN,
  //     cdnHost: 'https://cdn.judge.me',
  //     delay: 500,
  //   });
  // }

  return (
    <>
      <Header location={location} isSiteFramed={isSiteFramed} />
      {children}
      <Footer isSiteFramed={isSiteFramed} />
    </>
  )
}

export default Layout
